import React, { useState } from 'react'
import emailjs from 'emailjs-com';
import TimeKeeper from 'react-timekeeper';
import Swal from 'sweetalert2'


const Apoinment = () => {

    const [hour, setHour] = useState('12:30pm')
    const [customerName, setCustomerName] = useState('')
    const [customerEmail, setCustomerEmail] = useState('')
    const [customerNumber, setCustomerNumber] = useState('')
    const [projectDescription, setProjectDescription] = useState('')
    const [appDate, setAppDate] = useState('')

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500
    });



    const handleCustomerName = e => {
        const { value } = e.target;
        setCustomerName(value);
    }

    const handleCustomerEmail = e => {
        const { value } = e.target;
        setCustomerEmail(value);
    }

    const handleCustomerNumber = e => {
        const { value } = e.target;
        setCustomerNumber(value);
    }

    const handleProjectDescription = e => {
        const { value } = e.target;
        setProjectDescription(value);
    }


    const handleCustomerAddress = e => {
        const { value } = e.target;
        setProjectDescription(value);
    }

    const handleDate = e => {
        const { value } = e.target;
        setAppDate(value);
    }



    function sendEmail(e) {
        e.preventDefault();
        //P
        emailjs.sendForm('service_delvalle', 'template_6hm8owp', e.target, 'user_ItfMXvsFpmcX7VVR2mXpI')
            .then((result) => {
                Toast.fire({
                    icon: 'success',
                    type: 'info',
                    background: "#fff",
                    title: "Message sent successfully"
                });
                window.location.reload(false);
            }, (error) => {
                Toast.fire({
                    icon: 'error',
                    type: 'error',
                    background: "#fff",
                    title: "We were unable to send your message, please try again."
                });
            });
    }


    return (

        <div className='containerApoinment'>
            <h1 style={{ color: '#101010' }} className='titleStep'>🌟Get a free quote 🌟</h1>
            <div style={{ height: '15px' }}></div>
            <span style={{ color: '#101010', fontsize: '14px' }}>Leave us your info and we’ll get back to you as soon as we can ✅</span>
            <div style={{ height: '15px' }}></div>
            <form className="contact-form" onSubmit={sendEmail}>

                <input onChange={handleCustomerName} placeholder='Your name' class="form-control m-2" type="text" name="customerName" />
                <input onChange={handleCustomerEmail} placeholder='Your email' class="form-control m-2" type="email" name="customerEmail" />
                <input onChange={handleCustomerNumber} placeholder='Your phone number' class="form-control m-2" type="number" name="customerNumber" />
                <input onChange={handleCustomerAddress} placeholder='Your address' class="form-control m-2" type="text" name="customerAddress" />
                <input onChange={handleProjectDescription} placeholder='Project description' class="form-control m-2" type="text" name="projectDescription" />

                {
                    /**
                    <label>Date of appointment</label>
                   <input className='form-control m-2' type="datetime-local" name='dateApp' onChange={handleDate} />
                   <textarea onChange={handleProjectDescription} placeholder='Project description' class="form-control m-2" name="projectDescription" />
                     */
                }

                <div style={{ width: '300px', justifyContent: 'center' }}>

                    <p style={{ fontSize: '10px', color: '#101010' }}>The personal information collected is only used by our team giving a  use that complies with these purposes. We do not share your information with any third parties.</p>
                </div>

                <input class="btn botonLlamar" type="submit" value="Send" />
            </form>

        </div>

    )
}

export default Apoinment;
